// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-moment-card {
  border-radius: 10px;
}

.content-image img {
  width: 100%;
  object-fit: cover;
  object-position: center center;
  cursor: pointer;
}

ion-card-content {
  --padding-start: 10px;
  --padding-end: 10px;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
}

.item-header {
  background-color: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}
.item-header h2 {
  margin: 0 0 2px 5px !important;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}
@media only screen and (min-width: 460px) {
  .item-header h2 {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
@media only screen and (min-width: 1450px) {
  .item-header h2 {
    font-size: 16px !important;
    margin: 0 0 2px 0 !important;
  }
}
.item-header p {
  font-size: 10px;
  margin: 0 0 0 5px !important;
}
@media only screen and (min-width: 460px) {
  .item-header p {
    font-size: 12px !important;
  }
}
@media only screen and (min-width: 1450px) {
  .item-header p {
    font-size: 14px !important;
    margin: 0 0 2px 0 !important;
  }
}

.item-header-colored {
  background-color: var(--ion-color-secondary);
  color: var(--planeed-color-white);
  padding-top: 0;
  padding-bottom: 0;
}
@media only screen and (min-width: 460px) {
  .item-header-colored {
    padding-top: 0;
    padding-bottom: 0;
  }
}

ion-card-content h2 {
  font-size: 15px;
  color: var(--ion-color-text-color);
  cursor: pointer;
}

button {
  background: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.skeleton {
  width: 100%;
  height: 200px;
}

.spaceBetween {
  display: flex;
  justify-content: space-between;
  --ion-grid-columns: 5;
}

.card-btn {
  display: flex;
  align-items: center;
  text-align: center;
  margin-bottom: 0;
}
.card-btn div {
  font-size: 11px;
  font-weight: normal;
}
.card-btn ion-icon {
  font-size: 22px;
  height: 22px;
  margin-bottom: 6px;
}
.card-btn ion-button {
  --padding-start: 0px;
  --padding-end: 0px;
  width: 100%;
}
.card-btn .greyText {
  color: #888;
}

ion-item {
  padding: 0;
  margin: 0;
  background: var(--planeed-color-white);
  border-radius: 0;
}

.item-header {
  background-color: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.item-header-colored {
  background-color: var(--ion-color-secondary);
  color: var(--planeed-color-white);
}

@media only screen and (min-width: 2560px) {
  .adjusted-col {
    margin-left: -30px;
  }
}

.item-header h2 {
  margin: 0;
  font-size: 14px;
}

.item-header p {
  margin: 0;
}

.content-image {
  z-index: 1;
  position: relative;
}

.content-image img {
  width: 100%;
}

.social-counter-ap {
  --ion-grid-columns: 5;
  border-bottom: 1px solid var(--planeed-color-lightgrey);
  color: var(--ion-color-medium);
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.social-counter-ap ion-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
.social-counter-ap span {
  margin-left: 5px;
  vertical-align: top;
}

.social-counter-ap-bottom {
  --ion-grid-columns: 5;
  color: var(--ion-color-medium);
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.social-counter-ap-bottom ion-col {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.social-counter-ap-bottom span {
  margin-left: 5px;
  vertical-align: top;
}

.social-counter-post-bottom {
  --ion-grid-columns: 5;
  color: var(--ion-color-medium);
  padding: 0;
  display: flex;
  align-items: center;
}
.social-counter-post-bottom ion-col {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.social-counter-post-bottom span {
  margin-left: 5px;
  vertical-align: top;
}

.social-counter {
  --ion-grid-columns: 5;
  border-bottom: 1px solid var(--planeed-color-lightgrey);
  color: var(--ion-color-medium);
  padding: 0;
  display: flex;
  align-items: center;
}
.social-counter ion-col {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
.social-counter span {
  margin-left: 5px;
}

ion-card-content h2 {
  font-size: 14px;
  color: var(--ion-color-text-color);
}

button {
  background: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.skeleton {
  width: 100%;
  height: 200px;
}

.comments-text {
  font-size: 12px;
  color: var(--ion-color-secondary);
  text-align: right;
  padding-right: 20px;
  text-decoration: underline;
  margin-top: 5px;
}

.menu-popover {
  --width: 204px !important;
  margin-left: -7px;
  --background: transparent;
}
.menu-popover ion-list {
  padding: 5px 0;
  margin: 0;
  border-radius: 10px;
  border: 2px var(--ion-color-secondary) solid;
  width: 200px;
  align-self: end;
}
.menu-popover ion-icon {
  font-size: 17px;
  margin: 0;
  padding: 0;
}
.menu-popover ion-label {
  padding: 0;
  margin: 0;
  color: var(--ion-color-secondary);
  font-size: 12px;
}
.menu-popover ion-item {
  padding: 0 20px;
  margin: 0;
  line-height: 40px;
}
.menu-popover ion-item::part(native) {
  min-height: 30px;
  font-size: 12px;
}
.menu-popover ion-item:last-child {
  --border-width: 0 0 0 0 !important;
  --inner-border-width: 0 0 0 0 !important;
}

.menu-box {
  text-align: center;
  justify-content: right;
  display: flex;
  align-items: center;
  font-size: 17px;
  margin: 0;
  padding: 0;
  float: right;
}

.thumb_img {
  border-radius: 50%;
  width: 40px !important;
  height: 40px !important;
  margin-right: 10px;
  object-fit: cover;
}

.comments-box {
  --ion-background-color: var(--planeed-color-white);
}
.comments-box ion-item {
  margin: 10px 10px;
}
.comments-box ion-icon {
  font-size: 17px;
  margin-left: 5px;
}

textarea {
  border-radius: 5px !important;
  background-color: var(--planeed-color-white) !important;
  padding: 14px 20px !important;
  font-size: 12px !important;
  z-index: 1 !important;
  width: calc(100% - 30px);
  margin-left: 2px;
  border: 1px solid var(--ion-color-tertiary-opacity);
  resize: none;
}

.comment-form {
  display: inherit;
}

.comment-form button {
  background: none;
}

ion-button {
  height: 55px;
  color: var(--ion-color-secondary);
  text-transform: capitalize;
}

ion-item {
  --padding-start: 0px !important;
  --padding-end: 0px !important;
  --inner-padding-start: 0px !important;
  --inner-padding-end: 0px !important;
  --background: var(--planeed-color-white);
}

.view-all-comments {
  color: #666666;
}

.avatar-icon {
  position: absolute;
  z-index: 6;
  margin-top: 0;
  margin-left: 5px;
  object-fit: cover;
  width: 65px !important;
  height: 65px !important;
  max-height: 65px !important;
  border: 2px solid var(--planeed-color-white);
  cursor: pointer;
}
@media only screen and (min-width: 460px) {
  .avatar-icon {
    margin-top: 5px;
  }
}

.profile-img {
  border-radius: 50%;
}

.company-profile-img {
  border-radius: 10px;
  background-color: var(--planeed-color-white);
}

.avatar-icon-colored {
  position: absolute;
  z-index: 6;
  margin-top: 0;
  margin-left: 5px;
  object-fit: cover;
  width: 65px;
  height: 65px;
  max-height: 65px;
  border: 2px solid var(--planeed-blue);
  cursor: pointer;
}
@media only screen and (min-width: 460px) {
  .avatar-icon-colored {
    margin-top: 5px;
  }
}

.avatar-box {
  height: 100%;
  padding-top: 16px;
}

.post-icon {
  position: relative;
  margin-left: 1px;
}

.post-tagline {
  font-size: 10px !important;
}
@media only screen and (min-width: 1450px) {
  .post-tagline {
    font-size: 14px !important;
  }
}
@media only screen and (min-width: 460px) {
  .post-tagline {
    font-size: 12px !important;
  }
}

.comment-reply {
  margin-left: 20px !important;
}

.comment-buttons {
  color: var(--ion-color-medium);
  font-size: 12px;
  margin: 0;
  padding: 0;
}
.comment-buttons ion-icon {
  font-size: 12px;
  position: relative;
  margin-top: 3px;
}

.comment-buttons span {
  width: 100px;
  min-width: 100px;
  margin: 0 12px 0 0;
}

.comment-border-link {
  display: block;
  position: absolute;
  top: 50px;
  left: 0;
  width: 12px;
  height: calc(100% - 50px);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  background-color: rgba(0, 0, 0, 0.1);
  background-clip: padding-box;
}

.rating-box {
  background: var(--planeed-color-white);
  padding-top: 3px;
}
.rating-box ion-col {
  text-align: center;
}

.metrik-icon {
  margin-bottom: -2px;
}

.popOverMenuButton {
  height: 17px;
  --padding-end: 0px;
  --padding-start: 0px;
}

ion-grid {
  --ion-grid-columns: 4;
}

.action-point-moment-image {
  width: 15px;
  height: 15px;
  border: 2px solid white;
  border-radius: 50px;
}

.browser-comment-container {
  max-height: 350px;
  overflow-y: auto;
  background-color: var(--planeed-color-white);
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.sticky-comment-box {
  padding: 0 5px 5px 10px;
  background: var(--planeed-color-white) !important;
}

.comment-input-box {
  width: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 10px;
  height: 100%;
}

.comment-btn {
  --padding-start: 5px;
  --padding-end: 5px;
}

.item-native {
  background-color: white;
}

.comment-input-box-modal {
  width: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 10px;
  margin-top: 2rem;
}

.comment-box-modal {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 2rem;
}

ion-modal::part(content) {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}

.bottom-content {
  --background: var(--planeed-color-white) !important ;
}

.comments-scrollable {
  flex: 1;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
  padding-bottom: 5rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
